import React, { useState } from 'react';
import ChangePasswordModal from './ChangePasswordModal';
import { hasOrganizerAccess } from '../lib/organizerAccess';

function Navbar({ user, onLogout, siteBranding }) {
    const [showChangePassword, setShowChangePassword] = useState(false);

    return (
        <nav className="bg-gray-900 border-b border-orange-500 px-4 py-3">
            <div className="max-w-6xl mx-auto flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <img
                        src="/favicon.svg"
                        alt=""
                        className="h-8 w-8 flex-shrink-0"
                    />
                    {siteBranding ? (
                        <div className="leading-tight">
                            <div
                                className="text-2xl font-black tracking-tight"
                                style={{ color: 'var(--org-primary, #fb923c)' }}
                            >
                                {siteBranding.display_name}
                            </div>
                            <div className="text-[10px] text-gray-500 tracking-wide">
                                Powered by HebertHoops.com
                            </div>
                        </div>
                    ) : (
                        <span className="text-2xl font-black text-white tracking-tight">
                            HEBERT<span className="text-orange-500">HOOPS</span>
                        </span>
                    )}
                </div>
                {user && (
                    <div className="flex items-center gap-4">
                        <span className="text-gray-300 text-sm hidden sm:block">
                            {user.name}
                            {user.is_platform_admin ? (
                                <span className="ml-2 bg-orange-500 text-white text-xs px-2 py-0.5 rounded-full">
                                    Admin
                                </span>
                            ) : hasOrganizerAccess(user) && user.plan_id === 'eval' ? (
                                <span className="ml-2 bg-gray-700 text-orange-400 text-xs px-2 py-0.5 rounded-full">
                                    Eval
                                </span>
                            ) : hasOrganizerAccess(user) ? (
                                <span className="ml-2 bg-gray-700 text-orange-400 text-xs px-2 py-0.5 rounded-full">
                                    Organizer
                                </span>
                            ) : user.organizer_status === 'active' ? (
                                <span className="ml-2 bg-yellow-900 text-yellow-400 text-xs px-2 py-0.5 rounded-full">
                                    Approved
                                </span>
                            ) : user.organizer_status === 'pending_review' ? (
                                <span className="ml-2 bg-yellow-900 text-yellow-400 text-xs px-2 py-0.5 rounded-full">
                                    Pending
                                </span>
                            ) : null}
                        </span>
                        <button
                            onClick={() => setShowChangePassword(true)}
                            className="text-sm text-gray-400 hover:text-white transition-colors"
                        >
                            Change password
                        </button>
                        <button
                            onClick={onLogout}
                            className="text-sm text-gray-400 hover:text-white transition-colors"
                        >
                            Sign out
                        </button>
                    </div>
                )}
            </div>
            {showChangePassword && (
                <ChangePasswordModal onClose={() => setShowChangePassword(false)} />
            )}
        </nav>
    );
}

export default Navbar;